import {Component, computed, Signal, signal, inject, Inject} from '@angular/core';
import {AppService} from "../../../app.service";
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {OrderService} from "../../../_services/order.service";
import {OrderItemsUtilsService} from "../../order-items-util.service";
import * as _ from "lodash";
import {OrderItemsDialogsService} from "../../order-items-dialogs.service";

@Component({
  selector: 'app-select-existing-offer-dialog',
  standalone: false,
  templateUrl: './select-existing-offer-dialog.component.html',
  styleUrl: './select-existing-offer-dialog.component.scss',
})
export class SelectExistingOfferDialogComponent {
	public appService = inject(AppService);
	public orderDialogs = inject(OrderItemsDialogsService);
	public enableEdit = true;

	wizardStep = signal(0);
	title: Signal<string> = computed(() => {
		return this.wizardStep() === 0 ? this.appService.translate('TD.this_offer_exists') : this.appService.translate('TD.select_offer_to_edit');
	});
	$storage;
	basket;

	constructor(
		public dialogRef: MatDialogRef<SelectExistingOfferDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		public dialog: MatDialog,
		public orderService: OrderService,
		public orderUtils: OrderItemsUtilsService,
	) {
		this.$storage = this.orderService.$storage;
		this.basket = this.$storage.basket;
		this.enableEdit = this.data.offer._enableEdit;
	}
	close() {
		this.dialogRef.close({});
	}
	addNew() {
		if (!this.enableEdit){
			this.duplicateOffer(this.data.existingOffers[0]);
			this.dialogRef.close( {});
		}else {
			this.dialogRef.close();
		}
	}
	gotoExisting() {
		if (this.data.existingOffers.length > 1) {
			this.wizardStep.set(1);
		} else {
			this.editOffer(this.data.existingOffers[0]);
		}
	}

	// ------------------------------------------------------------------------->
	// ------------------------------------------------------------------------->
	// ------------------------------------------------------------------------->

	editOffer(offer) {
		this.orderDialogs.openOfferDialog(offer, true).then((result: any) => {
			if (result) {
				if (result.mode === 'delete') {
					this.deleteOfferCont(offer);
					this.dialogRef.close(offer);
				}else {
					let index = this.basket.indexOf(offer);
					this.basket[index] = result["viewItem"];
					this.onChange();
					this.dialogRef.close(result["viewItem"]);
				}
			}
		});
	}

	deleteOffer(offer, deleteAll?) {
		if (offer.quantity > 1 && !deleteAll && !offer._reserved?.benefitId && !offer.isLoyaltyOffer) {
			//this.loyaltyService.removeSingleBenfitFromOffer(this.$storage, offer);
			--offer.quantity;
			this.onChange();
			return;
		}
		let args: any;
		if (offer._reserved?.benefitId) {
			args = {
				"content": this.appService.translate("_LOYALTY.confirmDeleteOffer_reserved"),
				showCancelButton: true,
				confirmText: this.appService.translate("_LOYALTY_REG.removeOfferButton"),
				cancelText: this.appService.translate("_LOYALTY_REG.keepOfferButton")
			}
		}
		else if (offer.isLoyaltyOffer) {
			args = {
				"content": this.appService.translate("_LOYALTY_REG.confirmDeleteOffer"),
				showCancelButton: true,
				confirmText: this.appService.translate("_LOYALTY_REG.removeOfferButton"),
				cancelText: this.appService.translate("_LOYALTY_REG.keepOfferButton")
			}
		} else {
			args = {
				"content": this.appService.translate("TO.q_remove_offer_from_basket"),
				showCancelButton: true,
				confirmText: this.appService.translate("remove")
			}
		}
		this.appService.confirm(args).then(() => {
			if (offer._reserved) {
				if (offer._reserved?.benefitId) {
					//this.loyaltyService.cancelBenefitFromOffer(this.$storage, offer._reserved?.benefitId);
				}
			}
			this.deleteOfferCont(offer);
			this.dialogRef.close(offer);
		});
	}
	deleteOfferCont(offer) {
		let index = this.basket.indexOf(offer);
		this.$storage.basket.splice(index, 1);
		//this.loyaltyService.getSelectedManualBenfitsCount(this.$storage);
		this.onChange(offer.isLoyaltyOffer ? 'deleteLoyaltyOffer' : 'deleteOffer');
	}

	duplicateOffer(offer) {
		this.orderService.validateOrderLimit(1, offer.total).then(() => {
			if (offer._reserved) {
				let newOffer = _.cloneDeep(offer);
				delete newOffer._reserved;
				newOffer._bid = this.orderUtils.getObjectId();
				newOffer.quantity = 1;
				this.$storage.basket.push(newOffer);
			} else {
				++offer.quantity;
			}
			this.onChange();
		});
	}

	onChange(args?) {
		this.orderService.cacheOrder();
		this.orderService.calculateBasketTotal();
	}

}
